/*eslint-disable */
const $ = window.jQuery = require('jquery');
import {
  bus
} from '@/main';
export default {
  name: 'lbil-linkage-blurb-popup',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
    setTimeout(() => {
      $(".lbil_linkage_popup").addClass("active");
    },100)
  },
  methods: {
    lbilLinkagePopupClosedMethod(){
      $(".lbil_linkage_popup").removeClass("active");
      setTimeout(() => {
        bus.$emit('lbilLinkagePopupStateBus', false)
      },100)
    },
  }
}


